import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, HostListener } from '@angular/core';
import { trigger, style, animate, transition, state } from '@angular/animations';
import { UtilitiesService } from '../../../../services/utilities.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { PostalCodeDataService } from 'src/app/services/postalcode-data-service';


@Component({
  selector: 'postal-code-resolver',
  templateUrl: './postal.component.html',
  styleUrls: ['./postal.component.scss'],
  animations: [
    trigger('openClose', [
      state('open', style({
        opacity: 1,
        display: 'block'
      })),
      state('closed', style({

        opacity: 0,
        display: 'none'

      })),
      transition('open => closed', [
        animate('0.5s')
      ]),
      transition('closed => open', [
        animate('0.5s')
      ]),
    ]),
  ]
})
export class PostalComponent implements OnInit, OnChanges {
  pattern = {
    'B': {
      pattern: new RegExp('\\d'),
      symbol: 'X'
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['changing'] != undefined) {
      var change = changes['changing'].currentValue
      if (change == true) {
        this.isOpen = change;
        this.tempContent = [];
        this.postalCode = '';
        this.showDdl = false;
      }
    }
  }
  @Input() enableChange = false;
  @Input() validations: string[]
  @Input() changing: boolean;
  @Input() countryCode: boolean;
  postalCode: string;
  isOpen: boolean = true;
  postalCodeValidation = '' as string;
  @Output() postalCodeSelect = new EventEmitter();
  @Output() isEnableSelectStates = new EventEmitter();
  searchTerm: string;
  showDdl: boolean;
  tempContent: any = [];
  arrowkeyLocation: any;
  @Input() postelCodeText = "" as string;
  constructor(private utilites: UtilitiesService, private toaster: ToastrService, private translate: TranslateService, private postalDataService: PostalCodeDataService
  ) {
    this.arrowkeyLocation = 0;
  }

  @HostListener('window:keyup.enter')
  // takeFromSearchCountries = ["GB", "CA","NL","IM"]
  takeFromSearchCountries(): string[] {
    return ["GB", "CA", "NL", "IM", "JE"];
  }
  changeByEnterkey() {
    if (this.searchTerm != '' && this.searchTerm != undefined) {
      var _postalCode = this.tempContent as any[];
      var postalCode = _postalCode[this.arrowkeyLocation];

      if (postalCode) {
        this.showDdl = false;
        this.isOpen = !this.isOpen;

        // if (this.takeFromSearchCountries.findIndex(m=> m == postalCode.CountryCode) > -1)
        if (this.takeFromSearchCountries().indexOf(postalCode.CountryCode) > -1)
          this.postelCodeText = this.searchTerm;
        else
          this.postelCodeText = postalCode.PostCodePrefix + postalCode.PostCodeFrom;

        postalCode.postelCode = this.postelCodeText;
        // postalCode.postelCode = this.searchTerm.startsWith("0") ? "0" + postalCode.postelCode : postalCode.postelCode;
        var countryInfo = postalCode;
        //countryInfo = this.searchTerm.startsWith("0") ? "0" + countryInfo : countryInfo;
        this.postalCodeSelect.emit(countryInfo);
        this.isEnableSelectStates.emit(true);
      }
      else {
        this.toaster.error(`${this.translate.instant('pages.createReceiptPage.enterValidPostalCode')}`);
      }

    }
    this.searchTerm = '';
  }
  changeByClick(item, isClose?) {
    if (item) {
      this.showDdl = false;
      this.isOpen = isClose ? !isClose : !this.isOpen;
      //if (this.takeFromSearchCountries.findIndex(m => m == item.CountryCode) > -1)
      if (this.takeFromSearchCountries().indexOf(item.CountryCode) > -1)
        this.postelCodeText = this.searchTerm;
      else
        this.postelCodeText = item.PostCodePrefix + item.PostCodeFrom;

      item.postelCode = this.postelCodeText;
      //item.postelCode = this.searchTerm.startsWith("0") ? "0" + item.postelCode : item.postelCode;
      var countryInfo = item;
      // countryInfo = this.searchTerm.startsWith("0") ? "0" + countryInfo : countryInfo;
      this.postalCodeSelect.emit(countryInfo);
      this.isEnableSelectStates.emit(true);
    }
    else {
      this.toaster.error(`${this.translate.instant('pages.createReceiptPage.enterValidPostalCode')}`);
    }
  }

  ngOnInit() {
  }

  //getpostelCode() {
  //    if (this.postalCode == '' || this.postalCode == null) {
  //        this.postalCodeValidation = '<i class="unvalid armx - icon armx-cancel"></i> Postal code is required ';
  //    }
  //    else {
  //        this.postalCodeSelect.emit(this.postalCode);
  //        this.isEnableSelectStates.emit(true);
  //        this.isOpen = !this.isOpen;
  //    }
  //}

  change() {
    this.isEnableSelectStates.emit(false);
    this.searchTerm = '';
    this.isOpen = !this.isOpen;
  }

  search(e) {
    if (e.target) {
      if (this.searchTerm != "" && this.searchTerm != undefined && this.searchTerm.length > 2) {
        this.utilites.getPostCodes(this.countryCode, this.searchTerm, (res) => {
          this.tempContent = res.Results;
          let apiText = this.postalDataService.genratePostalCodeKey(this.countryCode, this.searchTerm);
          this.postalDataService.addPostalCodes(apiText, res.Results);
          this.showDdl = true;
        }, (err) => { })
      }
      else {
        this.tempContent = [];
        this.showDdl = false;
      }
    }
  }

  @HostListener('window:keydown', ['$event'])
  onarrowDown(event) {
    if (event.key == 'ArrowDown') {
      if (this.arrowkeyLocation < this.tempContent.length - 1)
        return this.arrowkeyLocation++;
    }
    else {
      if (event.key == 'ArrowUp') {
        if (this.arrowkeyLocation > 0)
          return this.arrowkeyLocation--;
      }
    }
  }

}
